/**
 * Aliases PT/normalizados → chave em VIP_ITEM_PRICES.
 * Gerado por: node scripts/generate-price-aliases.cjs
 */
export const VIP_PRICE_KEY_ALIASES = {
    "abobora": "Pumpkin",
    "acelerador de cano": "Muzzle_Boost",
    "alarme inteligente": "Ceiling_Light",
    "alarme sonoro": "Ceiling_Light",
    "aquecedor eletrico": "Ceiling_Light",
    "armadilha": "Snap_Trap",
    "armadilha de escopeta": "Snap_Trap",
    "armario": "Table",
    "armario de ferramentas": "Table",
    "arpao": "Crossbow",
    "aspersor": "Ceiling_Light",
    "bala de alta velocidade de pistola": "5.56",
    "bala de pistola": "5.56",
    "bala incendiaria de pistola": "5.56",
    "balaclava de pano": "Burlap_Headwrap",
    "balaclava improvisada": "Improvised_Balaclava",
    "balote calibre 12": "5.56",
    "bancada de reparo": "Repair_Bench",
    "bandagem": "SCRAP",
    "bandana": "Bandana_Mask",
    "barco a motor": "SCRAP",
    "barra de chocolate": "Chocolate_Bar",
    "barra de granola": "Granola_Bar",
    "barricada de concreto": "Table",
    "barricada de madeira": "Table",
    "barricada de metal": "Table",
    "barricada de pedra": "Table",
    "barricada de sacos de areia": "Table",
    "barril de agua": "Table",
    "bateria grande recarregavel": "Ceiling_Light",
    "bateria media recarregavel": "Ceiling_Light",
    "bateria pequena recarregavel": "Ceiling_Light",
    "bau grande de madeira": "Large_Wood_Box",
    "binoculos": "Binoculars",
    "bloqueador": "Ceiling_Light",
    "blusao": "Hoodie",
    "bobina de tesla": "Ceiling_Light",
    "bomba d'agua": "Ceiling_Light",
    "bomba de petroleo": "Table",
    "botao": "Ceiling_Light",
    "botas": "Boots",
    "britadeira": "JACKHAMMER",
    "caixa de entrega": "Table",
    "caixa grande de madeira": "Table",
    "caixa pequena de madeira": "Wood_Storage_Box",
    "calca": "Pants",
    "calca blindada": "Heavy_Plate_Pants",
    "calca de couro": "Hide_Pants",
    "calca de madeira": "Wood_Armor_Pants",
    "cama": "Bed",
    "camera cctv": "SCRAP",
    "camera cctv ptz": "Ceiling_Light",
    "camisa": "Shirt",
    "camiseta": "T-Shirt",
    "camiseta manga longa": "Longsleeve_T-Shirt",
    "canteiro de plantas grande": "Note",
    "canteiro de plantas pequeno": "Note",
    "capacete blindado": "Heavy_Plate_Helmet",
    "capacete de balde": "Bucket_Helmet",
    "capacete de lata de cafe": "Coffee_Can_Helmet",
    "capacete de madeira": "Wood_Armor_Helmet",
    "capacete de manifestacao": "Riot_Helmet",
    "carga de demolicao": "Demolition_Charge",
    "carga explosiva com temporizador": "Timed_Explosive_Charge",
    "carregador estendido": "carregador_estendido",
    "cartao de acesso azul": "SCRAP",
    "cartao de acesso verde": "SCRAP",
    "cartao de acesso vermelho": "SCRAP",
    "cartucho artesanal": "5.56",
    "carvao vegetal": "SCRAP",
    "casaco de neve": "Snow_Jacket_-_Red",
    "cerca de arame": "Table",
    "cha": "SCRAP",
    "cha de cura": "SCRAP",
    "cha de madeira": "SCRAP",
    "cha de minerio": "SCRAP",
    "chapa de metal": "CHAPA",
    "chapeu de minerador": "Miners_Hat",
    "chapeu militar": "Beenie_Hat",
    "chumbo grosso calibre 12": "5.56",
    "cocar de lobo": "Wolf_Headdress",
    "colete blindado": "Heavy_Plate_Jacket",
    "colete de metal": "Metal_Chest_Plate",
    "colete de pele animal": "Hide_Vest",
    "coletor de agua pequeno": "Table",
    "coletor grande de agua": "Table",
    "combinador de fontes": "Ceiling_Light",
    "combinador industrial": "Ceiling_Light",
    "combustivel de baixa qualidade": "SCRAP",
    "combustivel diesel": "SCRAP",
    "compostor": "Note",
    "computador de mira": "SCRAP",
    "controlador de porta": "Table",
    "coquetel molotov": "Flame_Thrower",
    "corpo de semiautomatica": "Semi_Automatic_Body",
    "corpo de smg": "SMG_Body",
    "detector a laser": "Ceiling_Light",
    "divisor industrial": "Ceiling_Light",
    "elevador": "Ceiling_Light",
    "embrasura horizontal de metal": "Table",
    "embrasura vertical de metal": "Table",
    "engrenagens": "ENGRENAGEM",
    "enxofre": "SCRAP",
    "esconderijo pequeno": "Table",
    "escopeta cano d'agua": "Pump_Shotgun",
    "escopeta de cano duplo": "Pump_Shotgun",
    "escopeta de repeticao": "Pump_Shotgun",
    "escopeta spas 12": "SPAS",
    "escotilha de escada": "Table",
    "escotilha de escada triangular": "Table",
    "estacao de computador": "Ceiling_Light",
    "estacao de trabalho": "Note",
    "explosivos": "EXPLOSIVE",
    "fabricador industrial": "Ceiling_Light",
    "fechadura": "Table",
    "fechadura eletronica": "Table",
    "ferramenta de fio": "Ceiling_Light",
    "fliperama chippy": "testgenerator",
    "foguete": "ROCKET",
    "foguete de alta velocidade": "ROCKET DE ALTA",
    "foguete de fumaca": "5.56",
    "foguete incendiario": "FOGUETE_INCENDIARIO",
    "foguete lmf": "FOGUETE_LMF",
    "fornalha": "Furnace",
    "fornalha eletrica": "Ceiling_Light",
    "fragmentos de metal": "SCRAP",
    "fragmentos de ossos": "SCRAP",
    "frango cozido": "SCRAP",
    "freio de boca": "Muzzle_Brake",
    "fusivel eletrico": "ENGRENAGEM",
    "geladeira": "Fridge",
    "gerador de teste": "testgenerator",
    "gerador pequeno": "Ceiling_Light",
    "gordura animal": "SCRAP",
    "grade de madeira para janela": "Table",
    "grade de metal para janela": "Table",
    "grade de piso": "Table",
    "grade de piso triangular": "Table",
    "grades de janela reforcadas": "Table",
    "granada de fumaca": "Smoke_Grenade",
    "granada de fumaca de 40mm": "GRANADA_FUMACA_40MM",
    "granada de luz": "Flare",
    "granada explosiva de 40mm": "GRANADA_EXPLOSIVA_40MM",
    "granada f1": "GRANADA",
    "helicoptero de sucata": "SCRAP",
    "holofote": "Search_Light",
    "ignitor": "Ceiling_Light",
    "interruptor": "Ceiling_Light",
    "interruptor inteligente": "Ceiling_Light",
    "janela de vidro reforcado": "Table",
    "jaqueta": "Jacket",
    "jaqueta de placas de transito": "Road_Sign_Jacket",
    "kit medico grande": "SCRAP",
    "lamina de metal": "LAMINA",
    "lanca chamas": "Flame_Thrower",
    "lanca foguetes": "ROCKET",
    "lanca para arpao": "5.56",
    "lancador de granadas multiplas": "Grenade_Launcher",
    "lanterna de arma": "Weapon_Flashlight",
    "lanterna xing ling": "Note",
    "lata de atum": "Can_of_Tuna",
    "lata de feijao": "SCRAP",
    "local de sistema antiaereo": "SENTRY",
    "lona": "Tarp",
    "lr 300": "LR",
    "luvas de couro": "Leather_Gloves",
    "luvas de sinalizacao": "Leather_Gloves",
    "luvas taticas": "Leather_Gloves",
    "luz de parede industrial": "Ceiling_Light",
    "luz de teto": "Ceiling_Light",
    "luz simples": "Ceiling_Light",
    "machado recondicionado": "Hammer",
    "maquina de venda": "Vending_Machine",
    "martelo": "Hammer",
    "martelo recondicionado": "Hammer",
    "mascara de metal": "Metal_Facemask",
    "mascara de metal de gelo": "Metal_Facemask",
    "mesa de mistura": "Mixing_Table",
    "mesa de pesquisa": "Research_Table",
    "mesa de trabalho nivel 1": "Note",
    "mesa de trabalho nivel 2": "Table",
    "mesa de trabalho nivel 3": "MESA 3",
    "metal de alta qualidade": "SCRAP",
    "metralhadora caseira": "M249",
    "milho": "Corn",
    "mina terrestre": "Land_Mine",
    "minerio de enxofre": "SCRAP",
    "minerio de metal": "SCRAP",
    "minerio de metal de alta qualidade": "SCRAP",
    "minicoptero": "SCRAP",
    "mira 8x": "8X",
    "mira holografica": "HOLOGRAFICA",
    "mira laser": "LASER",
    "mira telescopica 16x": "Mira Telescópica de 16x",
    "mola de metal": "MOLA",
    "monitor de armazenamento": "Ceiling_Light",
    "motosserra": "MOTOSERRA",
    "mp5a4": "MP5",
    "municao 5 56 de alta velocidade de rifle": "5.56",
    "municao 5 56 de rifle": "5.56",
    "municao 5 56 explosiva de rifle": "5.56 EXPLOSIVA",
    "municao 5 56 incendiaria de rifle": "5.56",
    "municao antiaerea": "MUNICAO_ANTIAEREA",
    "municao de escopeta de 40mm": "5.56",
    "municao incendiaria calibre 12": "5.56",
    "muro alto de madeira": "Table",
    "muro alto de pedra": "Table",
    "oculos de visao noturna": "Night_Vision_Goggles",
    "painel solar grande": "Ceiling_Light",
    "pano": "SCRAP",
    "peitoral de madeira": "Wood_Chestplate",
    "persiana de madeira": "Table",
    "petroleo bruto": "SCRAP",
    "picareta de gelo recondicionada": "Hammer",
    "pistola m92": "M92",
    "pistola semiautomatica": "P2",
    "placas de transito": "PLACA",
    "planta de construcao": "Table",
    "polvora": "SCRAP",
    "porta de chapa de metal": "Table",
    "porta de madeira": "Table",
    "porta dupla de chapa de metal": "Table",
    "porta dupla de madeira": "Table",
    "portao alto de madeira": "Table",
    "portao alto de pedra": "Table",
    "portao de vedacao de arame": "Table",
    "purificador d'agua eletrico": "Ceiling_Light",
    "purificador de agua": "Table",
    "ramificador eletrico": "Ceiling_Light",
    "refinaria de petroleo pequena": "Note",
    "revolver python": "PYTHON",
    "rifle de assalto": "AK",
    "rifle de assalto de gelo": "LR",
    "rifle de ferrolho": "BOLT",
    "rifle l96": "L96",
    "rifle m39": "M39_Rifle",
    "rifle semiautomatico": "SEMI",
    "roupa de mergulho": "Hazmat_Suit",
    "saco de dormir": "Table",
    "saia de placas de transito": "Road_Sign_Kilt",
    "sela de cavalo": "Pants",
    "sela de cavalo dupla": "Pants",
    "sentinela automatica": "Auto_Turret",
    "sentinela lanca chamas": "Snap_Trap",
    "separador": "Ceiling_Light",
    "seringa medica": "SCRAP",
    "sinalizador de suprimentos": "Supply_Signal",
    "smg personalizada": "SUB",
    "sucata": "SCRAP",
    "sucata tecnologica": "ENGRENAGEM",
    "tanque de propano vazio": "Empty_Propane_Tank",
    "temporizador": "Ceiling_Light",
    "traje artico": "Traje_Artico",
    "traje de radiacao": "Hazmat_Suit",
    "traje ninja": "Traje_Ninja",
    "traje nomade": "Traje_Nomade",
    "transportador industrial": "Ceiling_Light",
    "tubo de metal": "ENGRENAGEM",
    "turbina eolica": "Wind_Turbine",
    "vitrine": "Table",
    "vitrine de metal": "Table",
};
